import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import { lighten } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useChallenge } from '../../../hooks';
import { UserAvatar } from '../../user';
import { medals } from '../medals';
export function LeaderboardIndividualItem({
  blurred,
  challengeType,
  item,
  prevItemRank,
  showSite,
  showTeam,
  site,
  team,
  valueLabel
}) {
  const {
    t
  } = useTranslation();
  const {
    getProgressValueWithUnit
  } = useChallenge();
  const medal = item && medals[item.rank - 1] || null;
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    paddingX: 2,
    paddingY: 1,
    sx: blurred ? {
      filter: 'blur(0.25rem)'
    } : {}
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexShrink: 0,
    height: 24,
    justifyContent: "center",
    width: 30
  }, !item ? /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 24
  }) : item.rank === prevItemRank ? /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, "-") : medal ? /*#__PURE__*/React.createElement("img", {
    src: medal.icon,
    width: 24
  }) : /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, Math.max(item.rank, item.leaderboardIndex || 0))), /*#__PURE__*/React.createElement(UserAvatar, {
    size: 48,
    user: item?.user
  }), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700,
    variant: "body2"
  }, item ? item.user?.username || t('commons.news.deleted_user') : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 200
  }))), showSite && /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    overflow: "hidden",
    width: 120
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    overflow: "hidden",
    textOverflow: "ellipsis",
    variant: "body2"
  }, item ? site || '-' : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 80
  }))), showTeam && /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    overflow: "hidden",
    width: 120
  }, !item ? /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 80
  }) : team ? /*#__PURE__*/React.createElement(_Box, {
    bgcolor: lighten(team.color, 0.9),
    border: `1px solid ${team.color}`,
    borderRadius: 1,
    component: "span",
    display: "inline-block",
    maxWidth: "100%",
    paddingX: "4px",
    paddingY: "2px",
    sx: {
      boxSizing: 'border-box',
      color: team.color
    }
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    overflow: "hidden",
    textOverflow: "ellipsis",
    variant: "body2"
  }, team.title)) : /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    variant: "body2"
  }, "-")), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 110
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    align: "right",
    variant: "body2"
  }, item ? valueLabel ?? (item.progressValue === 0 ? '-' : getProgressValueWithUnit(challengeType || 'bttf', item.progressValue)) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }))));
}
export default LeaderboardIndividualItem;